import licenseModule from '../../license.module';
import template from './licenseOverviewResource.component.html';
import style from './licenseOverviewResource.component.css';

export default licenseModule.component('licenseOverviewResource', {
    template,
    style,
    controller: ['entitlementConstants', licenseOverviewResourceComponent],
    bindToController: true,
    bindings: {
        cloudSubscriptionSummary: '<'
    }
});
function licenseOverviewResourceComponent(entitlementConstants) {
    var vm = this;
    vm.$onChanges = change;
    vm.elements = [];

    function render() {
        if (vm.cloudSubscriptionSummary != null) {
            vm.elements = [];

            var cloudStorage = {
                name: entitlementConstants.cloudStorage,
                total:
                    vm.cloudSubscriptionSummary.cloudStorageTotal /
                    (1024 * 1024 * 1024),
                used:
                    vm.cloudSubscriptionSummary.storage.usage /
                    (1024 * 1024 * 1024)
            };

            vm.elements.push(cloudStorage);

            var cloudBandwidth = {
                name: entitlementConstants.monthlyCloudBandwidth,
                total:
                    vm.cloudSubscriptionSummary.cloudBandwidthTotal /
                    (1024 * 1024 * 1024),
                used:
                    vm.cloudSubscriptionSummary.bandwidthDetail.usage != null
                        ? vm.cloudSubscriptionSummary.bandwidthDetail.usage /
                          (1024 * 1024 * 1024)
                        : 0
            };

            vm.elements.push(cloudBandwidth);
        }
    }

    function change(changeObj) {
        if (
            changeObj.cloudSubscriptionSummary.currentValue &&
            changeObj.cloudSubscriptionSummary.currentValue != null
        ) {
            render();
        }
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-overview-resource/licenseOverviewResource.component.js